import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import DataTable from "react-data-table-component";
import {connect} from "react-redux";
import {CustomerCustomersList} from "../../../../redux/actions/Modules.Action";
import ApiConnect from "../../../../Utils/ApiConnect";
import DeletePop from "../../../Components/DeletePop";
import NewCustomerModal from "./NewCustomerModal";

class index extends Component {
  constructor(props) {
    super(props);
this.state = {
      showModal: false,
      myFData: [],
      btnDisable: false,
      filterText: "",
    };
    this.columns = [
      {
        name: "Customer",
        selector: row => row.name,
        width: "300px",
        sortable: true,
        cell: (row) => {
          return (
            <React.Fragment>
              <div className="d-inline">
                {row.name}{" "}
                {row.register === "1" ? (
                  <span className="material-icons-outlined text-success fs-15">
                    verified
                  </span>
                ) : (
                  ""
                )}
              </div>
            </React.Fragment>
          );
        },
      },
      {
        name: "Contact",
        selector: row => row.id,
      },
      {
        name: "OTP",
        selector: row => row.otp,
      },
      {
        name: "Total Order",
        selector: row => row.total_order,
        sortable: true,
      },
      {
        name: "Reward Points",
        selector: row => row.reward_point,
        sortable: true,
      },
      {
        name: "Last Update",
        selector: row => row.last_visit,
        sortable: true,
      },
      {
        name: "Action",
        selector: row => row.action,
        className: "table-actions",
        width: "150px",
        sortable: false,
        cell: (row) => {
          return (
            <React.Fragment>
              <button className="table-action btn btn-square btn-pure hover-warning">
                <span className="material-icons-outlined">edit_note</span>
              </button>
              <button
                className="table-action btn btn-square btn-pure hover-danger"
                onClick={() =>
                  this.setState({ selectedId: row.id, triggerModal: true })
                }
              >
                <span className="material-icons-outlined">delete</span>
              </button>
            </React.Fragment>
          );
        },
      },
      ];
  }
  componentDidMount() {
    this.fetchCustomer();
  }

  customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };
  fetchCustomer() {
    ApiConnect.get("/Members/Information/CustomerList")
      .then((response) => {
        this.props.CustomerCustomersList(response.data.data);
      })
      .catch((error) => console.log(error));
  }
  handleChange() {}
  SettriggerModal = () => {
    this.setState({ selectedId: false, triggerModal: false });
  };
render() {
    const filteredData = this.props.CustomerList.filter(item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(this.state.filterText.toLowerCase())
      )
    );
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <header className="header no-border">
            <div className="header-info">
              <div className="left">
                <h2 className="header-title">
                  <strong>Customers</strong>
                </h2>
              </div>
              <div className="right gap-items-2">
                <button
                  className="btn btn-primary  btn-float btn-round"
                  onClick={() => {
                    this.setState({ showModal: true });
                  }}
                >
                  <span className="material-icons-outlined">add</span>
                </button>
              </div>
            </div>
            <div className="header-action"></div>
          </header>
          <div className="card-body">
            <div className="dataTables_wrapper">
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  onChange={e => this.setState({ filterText: e.target.value })}
                />
              </div>
              <DataTable
                className="table table-separated"
                keyField="id"
                columns={this.columns}
                data={filteredData}
                pagination
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                paginationPerPage={10}
                customStyles={this.customStyles}
                filter
                exportable
              />
            </div>
          </div>
          <Modal
            show={this.state.showModal}
            className="modal-center"
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Dialog>
              <Modal.Header>
                <h5 className="modal-title">New Customer</h5>
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.setState({ showModal: false })}
                >
                  <span>×</span>
                </button>
              </Modal.Header>
              <NewCustomerModal />
            </Modal.Dialog>
          </Modal>
          <DeletePop
            trigger={this.state.triggerModal}
            delUrl={`/Members/Information/DeleteCustomer?id=${this.state.selectedId}`}
            hideTrigger={this.SettriggerModal}
            fallAction={this.fetchCustomer}
          />
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    CustomerList: state.Customer.CustomerList,
  }),
  { CustomerCustomersList }
)(index);
